import PropTypes from 'prop-types'

import useTranslations from '../../../../i18n/useTranslations'
import { Typography, Box, Button, Link, MenuItem } from '@mui/material'

import { getFieldProps } from '../../../../common/formProps'
import { MOBILE_HOME_TABS } from '../../../../common/constants'

import Autocomplete from '../../../../ui/components/autocomplete'
import Select from '../../../../ui/components/select'
import FixedBottomWrapper from '../../../../ui/components/FixedBottomWrapper'
import TextField from '../../../../ui/components/textField'

import useFiltersModalForm from './useFiltersModalForm'

import styles from './styles'

const FiltersModalForm = ({
  type,
  initialFilters,
  statusOptions,
  serviceTypeOptions,
  onConfirm,
}) => {
  const t = useTranslations()

  const {
    formik: { values, fieldErrors, touched, handleChange },
    handleSubmit,
    handleReset,
    options,
  } = useFiltersModalForm(
    onConfirm,
    initialFilters,
    statusOptions,
    serviceTypeOptions,
  )

  return (
    <>
      <form onSubmit={handleSubmit} noValidate>
        <Box sx={styles.fieldsWrapper}>
          <Box sx={styles.fields}>
            {type === MOBILE_HOME_TABS.SHIPMENTS ? (
              <>
                {/* // El campo de statusCode es necesario mientras back no permita devolver listado
          // de envíos de varios statusCode (las no incidencias) */}
                <Autocomplete
                  labelId="statusCode"
                  id="statusCode"
                  options={options.statusCode}
                  isOptionEqualToValue={(option, value) => option === value}
                  name="statusCode"
                  noClearButton
                  inputProps={{
                    name: 'statusCode',
                    label: (
                      <Typography variant="label">
                        {t('noun:shippingStatusCode')}
                      </Typography>
                    ),
                    type: 'text',
                    ...getFieldProps(
                      'statusCode',
                      values,
                      fieldErrors,
                      touched,
                      t,
                    ),
                  }}
                  onChange={(_, value) =>
                    handleChange({ target: { name: 'statusCode', value } })
                  }
                  value={values.statusCode}
                  autoHighlight
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.code}>
                      {option.name}
                    </Box>
                  )}
                  fullWidth
                />
                <Autocomplete
                  options={options.serviceType}
                  isOptionEqualToValue={(option, value) =>
                    option.code === value.code
                  }
                  name="serviceType"
                  inputProps={{
                    name: 'serviceType',
                    label: (
                      <Typography variant="label">
                        {t('noun:service-type')}
                      </Typography>
                    ),
                    type: 'text',
                    ...getFieldProps(
                      'serviceType',
                      values,
                      fieldErrors,
                      touched,
                      t,
                    ),
                  }}
                  onChange={(_, value) => {
                    handleChange({ target: { name: 'serviceType', value } })
                  }}
                  value={values.serviceType}
                  autoHighlight
                  labelId="serviceType"
                  id="serviceType"
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.code}>
                      {option.name}
                    </Box>
                  )}
                  fullWidth
                />
              </>
            ) : null}

            <TextField
              name="senderAddress2"
              label={t('noun:city-origin')}
              value={values.senderAddress2}
              onChange={value =>
                handleChange({
                  target: { name: 'senderAddress2', value },
                })
              }
            />
            <TextField
              name="recipientAddress2"
              label={t('noun:city-destiny')}
              value={values.recipientAddress2}
              onChange={value =>
                handleChange({
                  target: { name: 'recipientAddress2', value },
                })
              }
            />
            <Select
              labelId="lastStatusDate"
              id="lastStatusDate"
              label={
                <Typography variant="label">
                  {t('noun:last-status-date')}
                </Typography>
              }
              name="lastStatusDate"
              {...getFieldProps(
                'lastStatusDate',
                values,
                fieldErrors,
                touched,
                t,
              )}
              className="input-full"
              onChange={e => {
                handleChange({
                  target: { name: 'lastStatusDate', value: e.target.value },
                })
              }}
            >
              {options?.lastStatusDate?.length
                ? options.lastStatusDate.map(option => (
                    <MenuItem key={option.id} value={`${option.id}`}>
                      {option.label}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </Box>
          <Link
            component="button"
            onClick={handleReset}
            sx={styles.deleteFiltersButton}
          >
            {t('home:filters:delete')}
          </Link>
        </Box>
        <FixedBottomWrapper fullWidth>
          <Button type="submit" fullWidth>
            {t('action:apply-filters')}
          </Button>
        </FixedBottomWrapper>
      </form>
    </>
  )
}

FiltersModalForm.propTypes = {
  type: PropTypes.oneOf(Object.values(MOBILE_HOME_TABS)),
  initialFilters: PropTypes.object,
  statusOptions: PropTypes.array,
  serviceTypeOptions: PropTypes.array,
  onConfirm: PropTypes.func,
}

export default FiltersModalForm
